import axios from "axios";
import authentication from "../../authentication";
export default {
  baseUrl: process.env.VUE_APP_API_ADMIN_SERVICE_BASE,
  async getGroups() {
    await authentication.isAuthenticated();
    return axios
      .get(
        `${this.baseUrl}/GetGroups/${authentication.getUser().profile.oid}`,
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          }
        }
      )
      .then(response => {
        return response.data;
      });
  }
};
